import { client } from "utils/api";

const getRootTaxonOptions = (q = null) =>
  new Promise(async (resolve, reject) => {
    try {
      const { data } = await client.get(
        `/root_taxons?context=list_with_product_ids&per_page=50${
          q ? `&q[name_or_identifier_matches]=%25${q}%25` : ""
        }`,
      );
      const options = data.map(({ id, name, identifier, product_ids }) => ({
        label: `${name} [${identifier}] (Ilość produktów: ${product_ids.length})`,
        name,
        identifier,
        value: id,
        product_ids: product_ids,
      }));
      resolve(options);
    } catch (error) {
      reject([]);
    }
  });
export default getRootTaxonOptions;
